import { useEffect, useRef, useState } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import QRCodeInputView from "./QRCodeInputView";
import QRCodeResultView from "./QRCodeResultView";
import QRCodeType from "./QRCodeType";
import { BASE_URL } from "../Config";

function QRCodeGeneratorMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "QR Code Generator & Barcode Generator Free",
  };

  //qrcode input value
  const [qrCodeInputValue, setQRCodeInputValue] = useState({
    value: "",
    type: QRCodeType.QR_CODE,
    popupShowing: false,
  });

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/qr_generator", title: "Generate QR Code For Free" },
    data2: { link: "/qr_generator", title: "Barcode Generator Free" },
    data3: { link: "/qr_generator", title: "Generate QR Codes For Business" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageContext.Provider value={{ qrCodeInputValue, setQRCodeInputValue }}>
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Generate QR codes online instantly. Create custom QR codes for URLs, text, and more with our fast, secure, and free QR code generator tool."
      ></meta>
      <meta
        name="keywords"
        content="qr code generator, generate qr code, create qr code online, qr code maker, qr generator online, custom qr code, free qr code generator, qr code creator, qr code tool, qr code generator free, online qr code maker, qr code generator for website, qr code generator for business, qr code generator tool, qr code generator online free"
      ></meta>

      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={false} />
        {/* QR Code input view */}
        <QRCodeInputView />
        {/* QR Code result view */}
        <QRCodeResultView />
        {/* Mid Section */}
        <MiscPageMidSection description="Our Barcode & QR Code Generator website provides a fast, secure, and reliable way to create barcodes and QR codes without requiring an internet connection. Built to work fully offline, this powerful tool allows users to generate codes directly on their device, ensuring complete privacy and data security. Whether you need to create codes for products, websites, payments, business cards, inventory, or marketing campaigns, this platform delivers accurate and high-quality results. Users can also choose online access when needed, making it flexible enough to function as a barcode generator online and QR code generator online while still offering offline processing. With customizable options such as size, color, format, and data type, users can easily create professional-looking codes for both personal and business use. Optimized for speed and usability, the generator supports multiple barcode standards and QR code formats, ensuring compatibility across devices and scanners. Ideal for businesses, retailers, educators, and marketers, this website simplifies code creation while maintaining reliability and performance. If you are searching for a secure barcode & QR code generator, a flexible barcode generator online, or a user-friendly QR code generator online with offline support, this platform delivers efficient solution designed for modern workflows." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Enter",
            step2: "Text",
            step3: "Generate",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="Barcode & QR Code Generator"
          why_use={[
            {
              title: "Quick and Easy Information Sharing",
              description:
                "Our Barcode & QR code generator makes it easy to share information like website links, product details, contact info, and payment links. Using a QR code generator online or offline allows instant access by scanning, saving time and effort.",
            },
            {
              title: "Improves Business Efficiency",
              description:
                "With a barcode generator online, businesses can manage inventory, billing, and product tracking efficiently. Barcodes help reduce manual errors and speed up daily operations across retail and logistics.",
            },
            {
              title: "Offline and Secure Code Generation",
              description:
                "Our offline Barcode & QR code generator ensures complete data privacy since files and data stay on your device. This is ideal for secure environments where online barcode generator access is limited.",
            },
            {
              title: "Boosts Marketing and Engagement",
              description:
                "This QR code generator online helps businesses connect customers to websites, social media, offers, and apps. QR codes improve user engagement and make digital marketing campaigns more effective.",
            },
            {
              title: "Cost-Effective and Free to Use",
              description:
                "Using a free Barcode generator or QR code generator free eliminates the need for expensive software or hardware. It is a budget-friendly solution for startups, small businesses, and individuals.",
            },
            {
              title: "Useful Across Multiple Industries",
              description:
                "Our Barcode & QR code generator is widely used in retail, healthcare, education, logistics, and events. From inventory management to student IDs, barcode generator online tools simplify workflows.",
            },
            {
              title: "Enhances Customer Experience",
              description:
                "QR codes created using a QR code generator online allow customers to quickly access menus, invoices, manuals, and support pages, improving convenience and customer satisfaction.",
            },
            {
              title: "Supports Multiple Barcode Formats",
              description:
                "Modern barcode generators online support QR codes, Code 128, EAN, UPC, and other formats, ensuring compatibility with scanners, mobile devices, and POS systems.",
            },
            {
              title: "Eco-Friendly and Paperless Solution",
              description:
                "Our QR code generator reduces the need for printed materials by enabling digital access to information, supporting paperless and environmentally friendly operations.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default QRCodeGeneratorMain;
